export const getImageDimensions = (file) => {
	return new Promise((resolve, reject) => {
		const img = new Image();
		const reader = new FileReader();

		// Load the image file as a Data URL
		reader.onload = (e) => {
			img.src = e.target.result;
		};

		img.onload = () => {
			resolve({ width: img.width, height: img.height });
		};

		img.onerror = (error) => {
			console.error('Error loading image', error);
			resolve(null); // Resolve with null if it's not an image
		};

		reader.readAsDataURL(file);
	});
};
